/**
 * CAFM Icon Directive
 * A custom directive to simplify icon usage with Material Symbols
 * Uses ligatures - icon name is rendered as text content
 * Also supports custom SVG icons defined in CSS
 *
 * @example <cafm-icon name="spinner" size="4x" pulse></cafm-icon>
 * @example <cafm-icon name="lock" fill></cafm-icon>
 * @example <cafm-icon name="delete" size="2x" class="text-danger"></cafm-icon>
 * @example <cafm-icon name="arrow-forward-new" rotated="expression"></cafm-icon>
 * @example <cafm-icon name="bell"></cafm-icon> (custom SVG icon)
 */
angular.module('elogbooksDirectives').directive('cafmIcon', [function () {
    // Mapping of aliased icon names to Material Symbol names
    // Only icons that differ from their class name need to be listed here
    var iconAliases = {
        'dashboard': 'clock_loader_20',
        'admin': 'lock',
        'eye-slash': 'visibility_off',
        'eye': 'visibility',
        'sign-in': 'login',
        'windows': 'arrow_right_alt',
        'envelope': 'mail',
        'spinner': 'cached',
        'caret-down': 'keyboard_arrow_down',
        'caret-up': 'keyboard_arrow_up',
        'caret-right': 'keyboard_arrow_right',
        'chevron-down': 'expand_more',
        'file': 'description',
        'add': 'add_2',
        'location': 'location_on',
        'service-types': 'format_list_bulleted',
        'arrow-right-new': 'arrow_back_ios_new',
        'arrow-down-new': 'arrow_back_ios_new',
        'arrow-left-new': 'arrow_back_ios_new',
        'arrow-forward-new': 'arrow_forward_ios',
        'minus': 'remove',
        'folder-check': 'folder_check_2',
        'alert': 'report',
        'mail-forward': 'forward_to_inbox'
    };

    // Icons that need special CSS transforms
    var transformedIcons = {
        'arrow-right-new': 'cafm-arrow-right-new',
        'arrow-down-new': 'cafm-arrow-down-new',
        'arrow-left-new': 'cafm-arrow-left-new'
    };

    return {
        restrict: 'E',
        replace: true,
        scope: {
            name: '@',      // Icon name (required) - e.g., "spinner", "lock", "delete"
            size: '@?',     // Size modifier - "2x", "3x", "4x"
            rotated: '=?',  // Boolean for rotated state
            svg: '@?',      // Use custom SVG icon instead of Material Symbol (default: false)
            title: '@?'
        },
        template: '<i class="cafm-icon" ng-class="iconClasses" data-ng-attr-title="{{title}}">{{iconName}}</i>',
        link: function (scope, element, attrs) {
            scope.iconClasses = {};
            scope.iconName = '';

            // Watch for name changes (supports interpolation like name="{{dynamicName}}")
            scope.$watch('name', function () {
                updateIcon();
            });

            // Watch for size changes
            scope.$watch('size', function () {
                updateIcon();
            });

            // Watch for rotated changes
            scope.$watch('rotated', function () {
                updateIcon();
            });

            function updateIcon() {
                var classes = {};
                var name = scope.name;

                if (name) {
                    if (iconAliases.hasOwnProperty(name)) {
                        // Aliased Material Symbol
                        scope.iconName = iconAliases[name];
                    } else {
                        // Standard Material Symbol: convert dashes to underscores
                        scope.iconName = name.replace(/-/g, '_');
                    }

                    // Add transform class if needed
                    if (transformedIcons.hasOwnProperty(name)) {
                        classes[transformedIcons[name]] = true;
                    }
                }

                // Add size class if specified
                if (scope.size) {
                    classes['cafm-' + scope.size] = true;
                }

                // Add fill class if attribute is present
                if (attrs.hasOwnProperty('fill')) {
                    classes['cafm-fill'] = true;
                }

                // Add animation classes if attributes are present
                if (attrs.hasOwnProperty('pulse')) {
                    classes['cafm-pulse'] = true;
                }

                if (attrs.hasOwnProperty('spin')) {
                    classes['cafm-spin'] = true;
                }

                // Add rotated class if rotated is true
                if (scope.rotated) {
                    classes['rotated'] = true;
                }

                scope.iconClasses = classes;
            }

            // Initial setup
            updateIcon();
        }
    };
}]);

